import './OrganizationMemberCard.css';

import React from 'react';
import { Box, Card, CardContent, CardHeader } from '@mui/material';
import { fullImagePath, generateClassName, toLocaleDateTime } from '../../../b2b-common/helpers';
import FieldText from '../../../b2b-common/FieldText';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const OrganizationMemberCard = ({ organizationMember, className = null }) => {
    const { t } = useB2BTranslation('b2b-users');

    if (!organizationMember) {
        return null;
    }

    return (
        <Card variant='outlined' className={generateClassName('organization-member-card', '', className)} >
            <CardHeader
                title={organizationMember.organization.organizationName}
                className='organization-member-card-header'
            />
            <CardContent className='organization-member-card-content'>
                <Box display={'flex'} flexDirection={'row'} gap={6} >
                    <Box className='organization-member-card-org-image' width={'150px'} height={'150px'} >
                        <img src={fullImagePath(organizationMember.organization.imagePath)} alt={organizationMember.organization.organizationName} className='organization-member-card-image' />
                    </Box>
                    <Box className='organization-member-card-member-roles' width={'calc(100% - 150px)'}
                        display={'flex'} flexDirection={'column'} gap={2}
                    >
                        <FieldText
                            label={t('Roles')}
                            labelAlign='left'
                            text={organizationMember.roles.map(role => role.roleName).join(', ')}
                            textAlign='left'
                        />
                        <FieldText
                            label={t('Member since')}
                            labelAlign='left'
                            text={toLocaleDateTime(organizationMember.membershipDate)}
                            textAlign='left'
                        />
                        <FieldText
                            label={t('Last login')}
                            labelAlign='left'
                            text={toLocaleDateTime(organizationMember.lastLoginDate, true)}
                            textAlign='left'
                        />
                    </Box>                        
                </Box>
            </CardContent>
        </Card>
    )
}

export default OrganizationMemberCard;